import React from 'react';
import StepFlowGrid from './StepFlowGrid';
import {
  couplingStoryHeading,
  couplingStoryIntro,
  couplingStorySteps,
  type CouplingStoryStep,
} from '../../content/siteMessaging';

/**
 * The core Coupling story, placed right under the hero: create your own
 * rewards or gift cards, let them travel across an open local network, and
 * run it all from the POS on your phone.
 */
export const CouplingStorySection: React.FC = () => (
  <section id="how-coupling-works" className="bg-[#fffaf4] px-4 pb-20 pt-6">
    <div className="mx-auto max-w-6xl">
      <div className="max-w-4xl">
        <span className="inline-flex rounded-full bg-white px-4 py-1 text-sm font-semibold text-brand-primary shadow-sm">
          How Coupling works
        </span>
        <h2 className="mt-6 text-4xl font-bold tracking-tight text-neutral-900 sm:text-5xl">
          {couplingStoryHeading}
        </h2>
        <p className="mt-4 text-lg leading-relaxed text-neutral-600">
          {couplingStoryIntro}
        </p>
      </div>

      <div className="mt-10">
        <StepFlowGrid<CouplingStoryStep>
          items={couplingStorySteps}
          getKey={(item) => item.step}
          gridClassName="md:grid-cols-3 xl:grid-cols-[1fr_auto_1fr_auto_1fr]"
          renderItem={(item) => (
            <article className="rounded-[1.75rem] border border-brand-primary/12 bg-white px-6 py-6 shadow-[0_20px_50px_rgba(130,64,29,0.08)]">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#fff2e4] text-lg font-bold text-brand-primary">
                {item.step}
              </span>
              <h3 className="mt-4 text-xl font-semibold text-neutral-900">
                {item.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-neutral-600">
                {item.description}
              </p>
            </article>
          )}
        />
      </div>
    </div>
  </section>
);

export default CouplingStorySection;
